import { render, staticRenderFns } from "./ReceiveTypeSwitcher.vue?vue&type=template&id=f74543e4&scoped=true&"
var script = {}
import style0 from "./ReceiveTypeSwitcher.vue?vue&type=style&index=0&id=f74543e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74543e4",
  null
  
)

export default component.exports